import Component from 'vue-class-component';
import moduleStore from './store/withDrawalList';
import Vue from 'vue';
import PageState from './store/state';

/**components**/
@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class withDrawalListPage extends Vue {
  state = new PageState();
  self: Vue = this;
  activeType = '';
  list = [];
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    this.getWithdrawalList();
  }
  mounted(moduleData: IinjectDatas) {
    document.title = '提现记录';
  }
  //切换tab页
  switchTab(e) {
    this.activeType = e.currentTarget.dataset.tab;
    this.getWithdrawalList()
  }
  //获取提现记录
  getWithdrawalList() {
    let vm = this;
    this.$http('getWithdrawalRecords',{status:this.activeType}).then(res => {
      if (res.code == 200) {
        vm.list = res.data;
      }
    });
    // this.list = [
    //     {
    //       appletId: 1,
    //       appletName: '葡萄微剧',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 160.75,
    //       canWithdrawCash: 160.75,
    //       withdrawOutCash: 0,
    //       status:'FINISHED',
    //     },
    //     {
    //       appletId: 2,
    //       appletName: '微剧吧',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 26.31,
    //       canWithdrawCash: 26.31,
    //       withdrawOutCash: 0,
    //       status:'CHECKING'
    //     },
    //     {
    //       appletId: 3,
    //       appletName: '冰糖故事会',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 11.31,
    //       canWithdrawCash: 11.31,
    //       withdrawOutCash: 0,
    //       status:'REJECT'
    //     },
    //     {
    //       appletId: 1,
    //       appletName: '葡萄微剧',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 160.75,
    //       canWithdrawCash: 160.75,
    //       withdrawOutCash: 0,
    //       status:'REJECT'
    //     },
    //     {
    //       appletId: 2,
    //       appletName: '微剧吧',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 26.31,
    //       canWithdrawCash: 26.31,
    //       withdrawOutCash: 0,
    //       status:'REJECT'
    //     },
    //     {
    //       appletId: 3,
    //       appletName: '冰糖故事会',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 11.31,
    //       canWithdrawCash: 11.31,
    //       withdrawOutCash: 0,
    //       status:'REJECT'
    //     },
    //     {
    //       appletId: 1,
    //       appletName: '葡萄微剧',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 160.75,
    //       canWithdrawCash: 160.75,
    //       withdrawOutCash: 0,
    //       status:'REJECT'
    //     },
    //     {
    //       appletId: 2,
    //       appletName: '微剧吧',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 26.31,
    //       canWithdrawCash: 26.31,
    //       withdrawOutCash: 0,
    //       status:'REJECT'
    //     },
    //     {
    //       appletId: 3,
    //       appletName: '冰糖故事会',
    //       appletIcon: '项目icon图标',
    //       totalIncome: 11.31,
    //       canWithdrawCash: 11.31,
    //       withdrawOutCash: 0,
    //       status:'REJECT',
    //       failReason:'pei',
    //       updatedAt: '2019-09-10 14:10:10'
    //     },
    //   ];
  }
}
